const shopifyStoreCountries = async () => {
  try {
    const response = await fetch('/api/shopify/shopifyStoreCountries');
    if (!response.ok) {
      const errorData = await response.json();
      console.error(
        'Failed to fetch Shopify store countries error:',
        errorData
      );
      throw {
        success: false,
        message: 'Error fetching Shopify store countries',
        data: errorData
      };
    }

    const data = await response.json();

    return { success: true, data: data.countries || [] };
  } catch (error) {
    console.error('Error fetching Shopify store countries:', error);
    throw {
      success: false,
      message: error.message,
      data: error.data
    };
  }
};

export { shopifyStoreCountries };
